import CenterLabelExtension from './center-label-extension';
import { componentFactory } from '../../../fc-core/src/lib';
import { priorityList } from '../../../fc-core/src/schedular';

var UNDEF,
    isDoughnut2D = function isDoughnut2D(a) {
  return 'Doughnut2D' === a.getName();
},
    isMultiLevelPie = function isMultiLevelPie(a) {
  return 'MultilevelPie' === a.getName();
},
    isChartAPI = function isChartAPI(a) {
  return 'chartAPI' === a.getType();
},
    isDataset = function isDataset(a) {
  return 'dataset' === a.getType();
},
    count = 0;

function centerLabel(a, b) {
  var c = this.apiInstance,
      d = c.getChildren('dataset')[0],
      e = d.getChildren(),
      f = e.centerLabel && e.centerLabel[0],
      g = c.config,
      h = function h() {
    var d,
        e,
        g = c.getDatasets()[0],
        h = g.config,
        i = h.piePlotOptions,
        j = i.innerSize;
    if (d = f.config, 'object' != typeof b) b = d;else {
      for (e in d) {
        b[e] === UNDEF && (b[e] = d[e]);
      }

      d = Object.assign(d, b);
    }
    b.label = a, d.label = a, g.centerLabelConfig = d, j && f && f.draw(a || '');
  };

  f === UNDEF && (componentFactory(d, CenterLabelExtension, 'centerLabel', 1, [g]), f = e.centerLabel && e.centerLabel[0]), c.addJob("eiMethods-center-lebel".concat(count++), h, priorityList.postRender);
}

export default {
  extension: function extension(a) {
    var b;
    a.addEventListener('instantiated', function (a) {
      var c = a.sender;
      b || (b = isChartAPI(c) && (isDoughnut2D(c) || isMultiLevelPie(c))), b && isDataset(c) && c.registerFactory('centerLabel', function () {
        var a = c.getFromEnv('chartConfig'),
            d = c.getFromEnv('chartInstance'),
            e = !!(a.centerlabel || a.defaultcenterlabel);
        d.centerLabel = centerLabel, componentFactory(c, CenterLabelExtension, 'centerLabel', e ? 1 : 0, [a]), b = UNDEF;
      });
    });
  },
  name: 'CenterLabelExtension',
  type: 'extension',
  requiresFusionCharts: !0
};